import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { FlexBoxColumn } from '@ecp/common/src/layouts/flex/styled';
import { Spacing } from '@ecp/common/src/layouts/Spacing';
import { TextBox } from '@ecp/common/src/text/TextBox';

import { yyyyMMddHHmmssToOtherFormat } from '@bo-utils/dateUtils';
import { ContentTitle } from '@bo-components/common/styled';
import Form from '@bo-components/common/form/Form';
import FormField from '@bo-components/common/form/FormField';

const SiteBasicInfo = ({ siteBasicInfo, jobGroupList }) => {
  const availablePeriod = useMemo(() => {
    if (siteBasicInfo.availableStartDate && siteBasicInfo.availableEndDate)
      return `${yyyyMMddHHmmssToOtherFormat(
        siteBasicInfo.availableStartDate,
        'yyyy-MM-dd HH:mm'
      )} ~ ${yyyyMMddHHmmssToOtherFormat(siteBasicInfo.availableEndDate, 'yyyy-MM-dd HH:mm')}`;

    return '';
  }, [siteBasicInfo]);
  const jobGroupNameList = useMemo(
    () => jobGroupList.map(({ jobGroupName }) => jobGroupName).join(', '),
    [jobGroupList]
  );

  return (
    <FlexBoxColumn width={'100%'} align-items={'flex-start'}>
      <ContentTitle type={'secondary'} width={'100%'}>
        사이트기본정보
      </ContentTitle>
      <Spacing bottom={'8px'} />
      <Form>
        <FormField label={'사이트명'}>
          <TextBox>{siteBasicInfo.siteName}</TextBox>
        </FormField>
        <FormField label={'사이트번호'}>
          <TextBox>{siteBasicInfo.siteNumber}</TextBox>
        </FormField>
        <FormField label={'웹사이트설명'} full>
          <TextBox>{siteBasicInfo.siteDesc}</TextBox>
        </FormField>
        <FormField label={'사이트유형'}>
          <TextBox>{siteBasicInfo.siteTypeCodeName}</TextBox>
        </FormField>
        <FormField label={'계약기간'}>
          <TextBox>{availablePeriod}</TextBox>
        </FormField>
        <FormField label={'운영구분'}>
          <TextBox>{siteBasicInfo.siteOperationCodeName}</TextBox>
        </FormField>
        <FormField label={'데이터조회권한'}>
          <TextBox>{jobGroupNameList}</TextBox>
        </FormField>
        <FormField label={'수신거부ARS사용여부'}>
          <TextBox>{siteBasicInfo.recvDsagArsUseYn}</TextBox>
        </FormField>
        <FormField label={'수신거부ARS전화번호'}>
          <TextBox>{siteBasicInfo.recvDsagArsTel}</TextBox>
        </FormField>
      </Form>
    </FlexBoxColumn>
  );
};

export default SiteBasicInfo;

SiteBasicInfo.propTypes = {
  siteBasicInfo: PropTypes.object,
  jobGroupList: PropTypes.arrayOf(PropTypes.object),
};
